export const ORDERS_FILTERS_FUNCTIONS = Object.freeze({
  guestRequestOrdersLocalFilter: (order) =>
    order.vendor_order_id !== '__FAILED_TO_SUBMIT__',
});

export const MAX_DEPTH = 9;
export const MAX_CHILDREN = 48;

export const GR_NODE_TYPES = Object.freeze({
  serviceCategories: 'service_categories',
  serviceIssues: 'service_issues',
});
